
export const HPTopNavRules = {
    standard: {
        showApply: true,
        showKbyg: true,
        showProposal: false,
        showContact: true,
        showPersonalInfo: true,
        showCoQR: false,
        showReports: false,
    },
    suspendedCompliance: {
        showApply: false,
        showKbyg: false,
        showProposal: false,
        showContact: true,
        showPersonalInfo: true,
        showCoQR: false,
        showReports: false,
    },
    benjiView: {
        showApply: false,
        showKbyg: false,
        showProposal: false,
        showContact: false,
        showPersonalInfo: true,
        showCoQR: false,
        showReports: false,
    },
};



// WEBPACK FOOTER //
// ./src/app/config/app.topNavRules.config.js